import React from "react";
import { withTranslation } from "react-i18next";
import { Image, Text, Button } from "@chakra-ui/react";
import { SceneLayout } from "src/components/SceneLayout";
import { H2 } from "src/atoms/typography";
import CloseButton from "src/atoms/CloseButton";
import LoadableContent from "src/components/LoadableContent";
import getImageSrc from "src/utils/getImageSrc";
import BackButton from "src/components/BackButton";

import VerifyCodeButton from "./VerifyCodeButton";
import TokenInput from "./TokenInput";
import PremiumBadge from "../../components/PremiumBadge";

class EnterTokenView extends React.Component {
  state = { token: "" };

  onTokenChange = (e) => this.setState({ token: e.target.value });
  handleTokenSubmit = (e) => {
    e.preventDefault();
    const { onTokenSubmit } = this.props;
    onTokenSubmit(this.state.token.trim());
  };

  render() {
    const { token } = this.state;
    const { t, isLoading, onClose, openHelp, isRestore, onBack } = this.props;
    return (
      <>
        <SceneLayout
          borderRadius="12px"
          bg="primary"
          as="form"
          onSubmit={this.handleTokenSubmit}
          absolute={
            <>
              {onBack && <BackButton absolute onClick={onBack} fill="white" />}
              <PremiumBadge top="19px" left={onBack ? "57px" : "24px"} />
              <CloseButton fill="white" absolute onClick={onClose} />
            </>
          }
          centerProps={{ width: "330px" }}
          center={
            <>
              <Image src={getImageSrc("premium.svg")} width="175px" />
              <H2 mt="16px" color="white">
                {t("purchase.enterToken.heading")}
              </H2>
              <LoadableContent showContent={!isLoading} color="white">
                <Text
                  mt="8px"
                  mb="26px"
                  color="white70"
                  lineHeight="1.29"
                  fontSize="14px"
                  letterSpacing="0.25px"
                  textAlign="center"
                >
                  {isRestore
                    ? t("purchase.enterToken.restore.text")
                    : t("purchase.enterToken.text")}
                </Text>
                <TokenInput
                  value={token}
                  type="text"
                  required
                  onChange={this.onTokenChange}
                  autoFocus
                  placeholder={t("enterCode")}
                />
              </LoadableContent>
            </>
          }
          bottomProps={{ mb: "16px" }}
          bottom={
            <>
              {!isLoading && (
                <VerifyCodeButton type="submit">
                  {t("buttons.continue")}
                </VerifyCodeButton>
              )}
              <Button
                variant="flatLight"
                type="button"
                mt="8px"
                onClick={openHelp}
              >
                {t("buttons.needHelp")}
              </Button>
            </>
          }
        />
      </>
    );
  }
}

export default withTranslation()(EnterTokenView);
